import React, { useEffect, useState } from 'react'
import { FiCheckCircle, FiXCircle } from 'react-icons/fi'
import { Link, useParams } from 'react-router-dom'
import Spinner from '../../components/Spinner'
import Card from '../../components/Card'
import { api } from '../../services/api'

export default function () {
	const { token } = useParams()

	const [dadosConfirmados, setDadosConfirmados] = useState(null)
	const [isTokenValid, setIsTokenValid] = useState(false)

	async function handleConfirmarAlteracaoAcesso() {
		try {
			await api.put(`usuario/email_alteracao/confirmacao/${token}`, {})

			setIsTokenValid(true)
			setDadosConfirmados(true)
		} catch(e) {
			setDadosConfirmados(false)
		}
	}

	useEffect(() => {
		if(token) {
			handleConfirmarAlteracaoAcesso()
		}
	}, [token])

	const isPending = dadosConfirmados === null

	return (
		<div className="sm:mx-36 mt-16 mb-16 2xl:mb-[40vh] animated fadeInUp faster">
			<Card className="flex flex-col gap-8 bg-white text-slate-800">
				{isPending ? (
					<div>
						<Spinner label="Confirmando seu e-mail..." />
					</div>
				) : (
					<>
						{isTokenValid ? (
							<>
								<div className="flex flex-col items-center gap-2">
									<FiCheckCircle size={56} className="text-emerald-400" />
									<h1 className="text-center text-slate-800">Seu e-mail está confirmado!</h1>
								</div>

								<p className="text-center">Você já pode usar seu novo e-mail para fazer login na sua conta.</p>
							</>
						) : (
							<>
								<div className="flex flex-col items-center gap-2">
									<FiXCircle size={56} className="text-red-500" />
									<h1 className="text-center text-slate-800">Link não reconhecido!</h1>
								</div>

								<p className="text-center">Verifique o endereço acessado e tente novamente.</p>
								
								<p className="text-center">Obs.: Talvez você já tenha confirmado seu e-mail anteriormente.</p>
							</>
						)}

						<Link to="/login" className="button self-center">
							Ir para o login
						</Link>
					</>
				)}
			</Card>
		</div>
	)
}
